import React, { useState } from "react"
import OfflineDownload from "features/OfflineDownload/OfflineDownload"
import InstallInstructionsModal from "features/InstallInstructionsModal/InstallInstructionsModal"
import { isStandaloneApp } from "shared/utils/isStandaloneApp"
import css from "./Footer.module.scss"

export default function Footer() {
  const [installModalOpen, setInstallModalOpen] = useState(false)
  // Already running as the installed Electron app or an installed PWA — a
  // "download the app" prompt makes no sense from inside the app itself.
  const [showPlatformDownloads] = useState(() => !isStandaloneApp())

  return (
    <footer className={css.footer}>
      <OfflineDownload />

      {showPlatformDownloads && (
        <div className={css.downloads}>
          <h2 className={css.downloadsTitle}>Download</h2>
          <div className={css.downloadsRow}>
            <button type="button" className={css.downloadButton} disabled title="Coming soon">
              Win (.exe)
            </button>
            <a className={css.downloadButton} href={`${process.env.PUBLIC_URL}/jaster-igla.dmg`} download>
              Mac (.dmg)
            </a>
            <button type="button" className={css.downloadButton} onClick={() => setInstallModalOpen(true)}>
              Mobile (.pwa)
            </button>
          </div>
        </div>
      )}

      {installModalOpen && <InstallInstructionsModal onClose={() => setInstallModalOpen(false)} />}
    </footer>
  )
}
